const Education = [
  {
    title: 'Gestion de projet et management',
    year: '2013',
    school: 'Formation professionnelle',
    htmlContent: 'Formation dispensé en entreprise.',
  },
  {
    title: 'Cours du soir',
    year: '2012',
    school: 'Conservatoire national des arts et des métiers',
    htmlContent: `
        <ul>
        <li>Systèmes de gestion de base de données</li>
        <li>Méthodologie des systèmes d’information</li>
        <li>Systèmes d’information web</li>
        <li>Réseaux et télécommunications</li>
        <li>Technologies pour les applications client-serveur</li>
        <li>Systèmes informatiques et applications concurrentes</li>
        <li>Génie logiciel</li>
        <li>Management social et communication dans l’entreprise</li>
        <li>Anglais</li>
        </ul>
        `,
  },
  {
    title: 'BTS Informatique et réseaux dans l’industrie et les services.',
    year: '2011',
    school: 'LPO Baimbridge',
    htmlContent: "Maîtrise des fondamentaux d'un système informatique. ",
  },
  {
    title: 'Baccalauréat Sciences et techniques de l’ingénieur.',
    year: '2009',
    school: 'LPO Baimbridge',
    htmlContent: '',
  },
  {
    title: "BEP Métiers de l'électronique",
    year: '2007',
    school: 'LPO Ducharmoy',
    htmlContent:
      "Fondamentaux de l'électronique, base intéressante pour travailler sur de l'embarqué",
  },
];

export default Education;
